import { Button } from "@mui/material";
import { DataGrid } from "@mui/x-data-grid";
import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Link } from "react-router-dom";
import Loader from "../Layout/Loader";
import { getAllOrdersOfShop } from "../../redux/actions/order";
import { AiOutlineArrowRight } from "react-icons/ai";

const AllOrders = () => {
  const { orders, isLoading } = useSelector((state) => state.order);
  const { seller } = useSelector((state) => state.seller);

  const dispatch = useDispatch();

  // Filter and Sort persistence
  const [filterModel, setFilterModel] = useState({ items: [] });
  const [sortModel, setSortModel] = useState([]);

  useEffect(() => {
    // Load saved filters only if navigating back (not on fresh page load)
    const navigationEntry = performance.getEntriesByType('navigation')[0];
    const isPageReload = navigationEntry && navigationEntry.type === 'reload';
    
    if (!isPageReload) {
      const savedFilter = sessionStorage.getItem('shopAllOrdersFilterModel');
      const savedSort = sessionStorage.getItem('shopAllOrdersSortModel');
      
      if (savedFilter) {
        setFilterModel(JSON.parse(savedFilter));
      }
      if (savedSort) {
        setSortModel(JSON.parse(savedSort));
      }
    } else {
      // Clear filters on page reload
      sessionStorage.removeItem('shopAllOrdersFilterModel');
      sessionStorage.removeItem('shopAllOrdersSortModel');
    }
  }, []);

  useEffect(() => {
    if (seller && seller._id) {
      dispatch(getAllOrdersOfShop(seller._id)); 
    }
  }, [dispatch, seller]);

  const columns = [
    { field: "id", headerName: "Order ID", minWidth: 150, flex: 0.7 },

    {
      field: "status",
      headerName: "Status",
      minWidth: 130,
      flex: 0.7,
      cellClassName: (params) => {
        return params.row.status === "Delivered"
          ? "greenColor"
          : "redColor";
      },
    },
    {
      field: "itemsQty",
      headerName: "Items Qty",
      type: "number",
      minWidth: 130,
      flex: 0.7,
    },

    {
      field: "total",
      headerName: "Total",
      type: "number",
      minWidth: 130,
      flex: 0.8,
    },

    {
      field: " ",
      flex: 1,
      minWidth: 150,
      headerName: "",
      type: "number",
      sortable: false,
      renderCell: (params) => {
        return (
          <>
            <Link to={`/order/${params.id}`}>
              <Button>
                <AiOutlineArrowRight size={20} />
              </Button>
            </Link>
          </>
        );
      },
    },
  ];
 
  const row = [];

  orders &&
    orders.forEach((item) => {
      row.push({
        id: item._id,
        itemsQty: item.cart.length,
        total: " Rs " + item.shopTotalOrderPriceWithoutCommission,
        status: item.status,
      });
    });

  return (
    <>
      {isLoading ? (
        <Loader />
      ) : (
        <div className="w-full bg-white">
          <div className="datagrid-scroll-wrapper">
            <div className="table-inner-container" style={{ minWidth: "700px" }}>
              <DataGrid
                rows={row}
                columns={columns}
                pageSize={10}
                disableSelectionOnClick
                autoHeight
                filterModel={filterModel}
                onFilterModelChange={(newFilterModel) => {
                  setFilterModel(newFilterModel);
                  sessionStorage.setItem('shopAllOrdersFilterModel', JSON.stringify(newFilterModel));
                }}
                sortModel={sortModel}
                onSortModelChange={(newSortModel) => {
                  setSortModel(newSortModel);
                  sessionStorage.setItem('shopAllOrdersSortModel', JSON.stringify(newSortModel));
                }}
                sx={{
                  border: "none",
                  "& .MuiDataGrid-virtualScroller": {
                    overflow: "visible !important",
                  },
                }}
              />
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default AllOrders;
